import { JuniorPilotResponse } from 'src/sdk-servicing';
import { createAction, props } from '@ngrx/store';
import { asyncProps, FromApiActionPayload, WithRequestId, AsyncRequest } from '@lib/store';
import { JuniorPilotModel } from './junior-pilot.state';

/** StateDetailsActions */
const ACTION_SET = '[JuniorPilot] set';
const ACTION_UPDATE = '[JuniorPilot] update';
const ACTION_RESET = '[JuniorPilot] reset';
const ACTION_FAIL = '[JuniorPilot] fail';
const ACTION_CANCEL_REQUEST = '[JuniorPilot] cancel request';

/** Async Actions */
const ACTION_SET_FROM_API = '[JuniorPilot] set from api';
const ACTION_UPDATE_FROM_API = '[JuniorPilot] update from api';

/**
 * Clear the current store object and replace it with the new one,
 * update isFailure to false, and update isPending with the boolean given as parameter if defined
 */
export const setJuniorPilot = createAction(ACTION_SET, props<WithRequestId<JuniorPilotModel>>());

/**
 * Change a part or the whole object in the store and update isFailure to false. The pendingUpdate boolean,
 * if set to true or false, will update the isPending property from the StateDetails
 */
export const updateJuniorPilot = createAction(ACTION_UPDATE, props<WithRequestId<Partial<JuniorPilotModel>>>());

/**
 * Clear the whole state, return to the initial one
 */
export const resetJuniorPilot = createAction(ACTION_RESET);

/** Action to cancel a Request ID registered in the store. Can happen from effect based on a switchMap for instance */
export const cancelJuniorPilotRequest = createAction(ACTION_CANCEL_REQUEST, props<AsyncRequest>());

/**
 * Update isPending from the StateDetails to false, and isFailure to true
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const failJuniorPilot = createAction(ACTION_FAIL, props<WithRequestId<{ error: any }>>());

/**
 * Update isPending to true, triggers setFromApi Effect
 */
export const setJuniorPilotFromApi = createAction(
  ACTION_SET_FROM_API,
  asyncProps<FromApiActionPayload<JuniorPilotResponse>>()
);

/**
 * Update isPending to true, triggers updateFromApi Effect
 */
export const updateJuniorPilotFromApi = createAction(
  ACTION_UPDATE_FROM_API,
  asyncProps<FromApiActionPayload<JuniorPilotResponse>>()
);
